import React from 'react'
import { useLanguageContext } from '../../contexts/LanguageContext'
import './Mission.css'
import SEO from '../seo/SEO'

const Mission: React.FC = () => {
  const { content } = useLanguageContext()

  return (
    <>
    <SEO
        title={content.mission.seo.title}
        description={content.mission.seo.description}
      />
      <section id="mission" className="mission-section">
        <div className="container">
          <div className="mission-header text-center">
            <p className="section-subtitle">{content.mission.subtitle}</p>
            <h2 className="section-title">{content.mission.title}</h2>
            <p className="section-description">{content.mission.description}</p>
          </div>

          <div className="features-grid">
            {content.mission.features.map((feature: any, index: number) => (
              <div key={index} className="feature-card card">
                <img className='feature-icon' src={feature.image}/>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

<SEO
  title="Our Mission | Making Every Day Better with Technology"
  description="Learn how MakeMyDay uses positive technology, community support, and intelligent systems to help people feel better every day."
/>

export default Mission 